var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDialOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "26 21.55 21.84 17.55 21.84 19.79 18.01 19.79 18.01 23.39 21.84 23.39 21.84 25.55 26 21.55",
    style: {
      fill: "#9868b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.85,20l-.26.16c-.53.36-2.46.19-4.05-2.66s-.83-4.67-.27-4.89L11.34,12a1.12,1.12,0,0,0,.45-1.4L9.72,6.86A1.11,1.11,0,0,0,8.3,6.42c0,.07-1.14.61-1.14.7C5.58,8,4.78,9.85,4.87,12.45a15.25,15.25,0,0,0,2.2,6.85,17.07,17.07,0,0,0,4.77,5.41,8.87,8.87,0,0,0,1.95,1Z",
    style: {
      fill: "#7e7e7e"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialOther);
export default __webpack_public_path__ + "static/media/dial-other.9b822cc6.svg";
export { ForwardRef as ReactComponent };